export default {
      id: "ic-misc-marees-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-misc-marees-usage",
      toString: function () {
        return this.url;
      }
    }